<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-grey1">
    <h3 class="rs-tit6">{{ 'mobileapp.promo.title' | translate }}</h3>
    <p>{{ 'mobileapp.promo.description' | translate }}</p>
    <div class="rs-flex-row">
      <div class="rs-flex-column rs-flex-shrink">
        <a
          href="{{ 'mobileapp.promo.download.android.url' | translate }}"
          class="rs-link-no-decoration"
          [pxAnalyticsElementClicked]="{
            event_detail: 'download Google play',
            event_location: 'myWebMail.manage',
            event_action: 'click'
          }"
        >
          <img
            alt="Google Play Store"
            src="/dam/cdn/sites/iportal/images/illustrations/logos/Google_play_store_android.png.image"
          />
        </a>
      </div>
      <div class="rs-flex-column">
        <a
          href="{{ 'mobileapp.promo.download.ios.url' | translate }}"
          class="rs-link-no-decoration"
          [pxAnalyticsElementClicked]="{
            event_detail: 'download App store',
            event_location: 'myWebMail.manage',
            event_action: 'click'
          }"
        >
          <img
            alt="App Store"
            src="/dam/cdn/sites/iportal/images/illustrations/logos/App_store_appel.png.image"
            class="rs-padding-right2"
          />
        </a>
      </div>
    </div>
  </div>
</div>
